// extracted by mini-css-extract-plugin
module.exports = {"tekst":"dh-lyspunkt-v0-tekst-3d6_H"};